import { CameraPlugin } from '@capacitor/camera/dist/esm/definitions';

type CameraModuleCompat = typeof import('@capacitor/camera') | typeof import('capacitor7-camera');

export * from '@capacitor/camera/dist/esm/definitions';
// We are intentionally using a mutable export so that we can mimic the original import
// syntax for Capacitor plugins, while still dynamically loading the correct capacitor version.
// Don't remove or try to fix the skipcq, as this syntax is mandatory for the compatibility bridge.
// skipcq: JS-E1009
export let Camera: CameraPlugin;

const load = (module: CameraModuleCompat) => {
  Camera = module.Camera as CameraPlugin;
};

export default load;
